import { Event } from '../events'
import { EventTracker } from './EventTracker'

/**
 * An EventTracker that intercepts calls to all event tracking methods and
 *   passes them to a single, generic method instead.
 */
export default abstract class GenericEventTracker extends EventTracker {
  public constructor() {
    super()

    EventTracker.getEventTrackingMethodNames().map((eventTrackingMethodName) => {
      if (this.constructor.prototype.hasOwnProperty(eventTrackingMethodName)) {
        return
      }

      this[eventTrackingMethodName] = (event: Event<any>) => {
        this.track(event)
      }
    })
  }

  public abstract track(event: Event): void
}
